import React, { useEffect, useRef } from 'react'
// AntV G2Plot
import { Column } from "@antv/g2plot"
// i18
import { useTranslation } from 'react-i18next'

export const Barras = ({graph}) => {
    const { t } = useTranslation(["translation"])
    const chartRef = useRef(null);

    useEffect(() => {

        const data = []
        if (graph===null) {
            data.push(
                {
                    name: `${t("ex")} 1`,
                    value: 40,
                },
                {
                    name: `${t("ex")} 2`,
                    value: 120,
                },
                {
                    name: `${t("ex")} 3`,
                    value: 80,
                },
                {
                    name: `${t("ex")} 4`,
                    value: 90,
                },
            )
        }
        else if(graph.channel) {
            const campos = graph.fields[graph.channel]
            campos.forEach(element => {
                const obj = {
                    name: element.name,
                    value: element.value
                }
                data.push(obj)
            });
        }
        else {
            const campos = graph.fields
            campos.forEach(element => {
                const obj = {
                    name: element.name,
                    value: element.value
                }
                data.push(obj)
            });
        }


        const columnPlot = new Column(chartRef.current, {
            data,
            xField: "name",
            yField: "value",
            label: {
                position: "middle",
                style: {
                    fill: "#FFFFFF",
                    opacity: 0.6,
                },
            },
            xAxis: {
                title: {
                    text: graph===null ? t("example") : graph.axis.x,
                    fontSize: 18,
                },
                label: {
                    autoHide: true, 
                    autoRotate: false,
                },
            },
            yAxis: {
                title: {
                    text: graph===null ? t("totals") : graph.axis.y,
                    fontSize: 18,
                },
                label: {
                    formatter: (v) => `${v}`,
                },
            },
            color: "#1890ff",
            animation: {
                appear: {
                    animation: "scale-in-y",
                    duration: 800,
                },
            },
        });

        columnPlot.render();

        return () => {
            columnPlot.destroy();
        };
    }, []);

    return <div ref={chartRef} style={{ width: "85%", height: "80%" }} />;
}
